import cloneDeep from 'lodash.clonedeep';

//todo: make the text keys dynamic somehow - move to be a concern of the caller rather than the editor
const SUPPORTED_DYNAMIC_TEXT_KEYS = new Set(['name', 'title', 'description', 'date', 'ownerName', 'clipLength']);

export function normalizeSurfaceEditorDynamicTextData(data = {}) {
  return data || {};
}

function isProvidedDynamicValue(value) {
  if (value === null || value === undefined) {
    return false;
  }

  if (typeof value === 'string') {
    return value.trim().length > 0;
  }

  return true;
}

export function interpolateSurfaceEditorTemplateString({template, data}) {
  if (typeof template !== 'string') {
    return {
      text: template,
      hasMatchedVariables: false,
      hasUnresolvedVariables: false
    };
  }

  const dynamicData = normalizeSurfaceEditorDynamicTextData(data);
  let hasMatchedVariables = false;
  let hasUnresolvedVariables = false;

  const text = template.replace(/{{\s*([^{}]+?)\s*}}/g, (match, key) => {
    const normalizedKey = String(key || '').trim();

    if (!SUPPORTED_DYNAMIC_TEXT_KEYS.has(normalizedKey)) {
      return match;
    }

    if (!Object.prototype.hasOwnProperty.call(dynamicData, normalizedKey)) {
      hasUnresolvedVariables = true;
      return match;
    }

    const value = dynamicData[normalizedKey];

    if (!isProvidedDynamicValue(value)) {
      hasUnresolvedVariables = true;
      return match;
    }

    hasMatchedVariables = true;
    return String(value);
  });

  return {
    text,
    hasMatchedVariables,
    hasUnresolvedVariables
  };
}

export function resolveSurfaceEditorTemplateText({surface, data}) {
  const resolvedSurface = cloneDeep(surface);
  const resolvedElements = [];

  for (const element of resolvedSurface?.elements || []) {
    if (element?.type !== 'text_box') {
      resolvedElements.push(element);
      continue;
    }

    const template = element?.content?.template;

    if (typeof template !== 'string' || !template.length) {
      resolvedElements.push(element);
      continue;
    }

    const {text, hasMatchedVariables, hasUnresolvedVariables} = interpolateSurfaceEditorTemplateString({template, data});

    if (hasUnresolvedVariables) {
      continue;
    }

    element.content = element.content || {};
    element.content.text = hasMatchedVariables ? text : template;
    resolvedElements.push(element);
  }

  resolvedSurface.elements = resolvedElements;

  return resolvedSurface;
}
